/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  async function checkAuth() {
    try {
      const res = await api.get('/auth/me/');
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  async function refreshUser() {
    try {
      const res = await api.get('/auth/me/');
      setUser(res.data);
      return res.data;
    } catch {
      setUser(null);
      return null;
    }
  }

  async function login(username, password, extra = {}) {
    const res = await api.post('/auth/login/', { username, password, ...extra });
    setUser(res.data);
    return res.data;
  }

  async function register(data) {
    const res = await api.post('/auth/register/', data);
    setUser(res.data);
    return res.data;
  }

  async function logout() {
    await api.post('/auth/logout/');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export default AuthContext;
